import { requireAuth } from '@portal/features/auth/guards'
import MainLayout from '@portal/features/layouts/MainLayout'
import { Header } from '@portal/features/navigation/Header'
import MainMenu from '@portal/features/navigation/MainMenu'
import OnboardingPage from '@portal/features/profile/OnboardingPage'
import { TextTitle } from '@portal/features/titles'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => (
  <MainLayout>
    <Header.Left>
      <MainMenu />
    </Header.Left>
    <Header.Center>
      <TextTitle title="Welcome, Adventurer" />
    </Header.Center>
    <OnboardingPage />
  </MainLayout>
)

export const Route = createFileRoute('/onboarding')({
  beforeLoad: requireAuth,
  component: RouteComponent,
})
